import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Por fin una guía que explica todo sin hacerme sentir que tengo algo grave. La leí en una tarde y entendí más que en años buscando en internet.',
    name: 'María G.',
    age: '34 años',
    image: 'https://cdn.magicpatterns.com/uploads/h4wX5AdqTSuJPztk1DjLsU/maria_g_34_anos.png'
  }, {
    quote: 'El diario de síntomas me ayudó a identificar que mis episodios siempre aparecen después de antibióticos. Nunca lo había conectado.',
    name: 'Valentina R.',
    age: '28 años',
    image: 'https://cdn.magicpatterns.com/uploads/iJWuwfGpyNLdokxj1ehrS8/Valentina_r_28_anos.png'
  }, {
    quote: 'Las preguntas para la consulta médica fueron lo que más me sirvió. Fui al ginecólogo con todo claro y salí con un plan real.',
    name: 'Carolina M.',
    age: '41 años',
    image: 'https://cdn.magicpatterns.com/uploads/iwqbXUF28oKExiXkDwcKq7/carolina_m_41_anos.png'
  }, {
    quote: 'Me la recomendó una amiga y entiendo por qué. Ojalá hubiera existido esto hace cinco años.',
    name: 'Daniela P.',
    age: '26 años',
    image: 'https://cdn.magicpatterns.com/uploads/4ca1uzz2w2hjvSiC9zXtWm/Daniela_P_26_anos.png'
  }];
  return <section className="py-16 md:py-24 px-4 bg-accent-lilac/20" data-id="element-268">
      <div className="max-w-6xl mx-auto" data-id="element-269">
        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-heading mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-270">
          Lo que dicen quienes ya la tienen
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-271">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white p-8 rounded-2xl shadow-lg" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-272">
              <QuoteIcon className="w-10 h-10 text-accent-blush mb-4" data-id="element-273" />
              <p className="text-body text-lg mb-6 leading-relaxed italic" data-id="element-274">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-gray-200 pt-4 flex items-center gap-4" data-id="element-275">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover ring-2 ring-accent-blush/40 shadow-sm" data-id="element-276" />
                <div data-id="element-277">
                  <p className="font-semibold text-heading" data-id="element-278">
                    {testimonial.name}
                  </p>
                  <p className="text-body text-sm" data-id="element-279">{testimonial.age}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}